import { z } from 'zod';

export const MainMenuItems = z.array(z.object({   
    Name: z.string(),
    URL: z.string(),
    Target: z.string(),
}));